// components/Tabs.tsx
import React, { useState, useEffect } from "react";
import { SearchTabContent } from "./SearchTabContent";
import { TabContent } from "./TabContent";
import { useOptionChainContext } from "../../../context/OptionChainContext";
import { useBuilderContext } from "../../StrategyCreator/context/BuilderContext";
import { useOptionChainScreenContext } from "../context/OptionChainContext";

const tabConfigs = [
  { label: "Nifty", scrip: "NIFTY" },
  { label: "Bank Nifty", scrip: "BANKNIFTY" },
  { label: "Fin Nifty", scrip: "FINNIFTY" },
  { label: "Sensex", scrip: "SENSEX" },
  { label: "Search", scrip: "" },
];

export default function Tabs({ preSelectedSymbol }) {
  const [searchScrip, setSearchScrip] = useState("");
  const { setSelectedSymbol, selectedSymbol, activeTab, setActiveTab } =
    useOptionChainScreenContext();
  const { allSymbols } = useBuilderContext();

  // Handle preselected symbol from InstrumentModal
  useEffect(() => {
    // Only process preSelectedSymbol if it exists (coming from /optionchain/:symbol)
    if (preSelectedSymbol && allSymbols) {
      // Check if the preselected symbol matches any of the default tabs
      const matchingTab = tabConfigs.find(
        (tab) => tab.scrip === preSelectedSymbol
      );

      if (matchingTab) {
        // If it matches a default tab, switch to that tab
        setActiveTab(matchingTab.label);
        const symbol = allSymbols.find((s) => s.scrip === preSelectedSymbol);
        if (symbol) setSelectedSymbol(symbol);
      } else {
        // If it doesn't match a default tab, switch to Search tab
        setActiveTab("Search");
        const symbol = allSymbols.find((s) => s.scrip === preSelectedSymbol);
        if (symbol) {
          setSelectedSymbol(symbol);
          setSearchScrip(preSelectedSymbol);
        }
      }
    }
    // If no preSelectedSymbol (coming from /optionchain), let the component use its default behavior
  }, [preSelectedSymbol, allSymbols, setSelectedSymbol, setActiveTab]);

  const isSearchTab = activeTab === "Search";
  const currentScrip = isSearchTab
    ? searchScrip
    : tabConfigs.find((tab) => tab.label === activeTab)?.scrip || "";

  const handleTabClick = (label) => {
    setActiveTab(label);
    if (label !== "Search") {
      setSearchScrip("");
      const scrip = tabConfigs.find((tab) => tab.label === label)?.scrip;
      const symbol = allSymbols?.find((s) => s.scrip === scrip);
      if (symbol) {
        // console.log('🔍 Tabs: Switching to symbol:', symbol.scrip);
        setSelectedSymbol(symbol);
      }
    }
  };

  return (
    <div className="w-full">
      <div className="flex text-gray-500 text-sm font-medium">
        {tabConfigs.map(({ label }) => (
          <div
            key={label}
            onClick={() => handleTabClick(label)}
            className={`px-4 py-2 cursor-pointer ${
              activeTab === label
                ? "text-p300 bg-p400 border-gray-200 rounded-t-md font-semibold z-10"
                : "hover:text-p300"
            }`}>
            {label}
          </div>
        ))}
      </div>

      <div className="">
        {isSearchTab ? (
          <SearchTabContent
            searchScrip={searchScrip}
            setSearchScrip={setSearchScrip}
            preSelectedSymbol={preSelectedSymbol}
          />
        ) : (
          <TabContent symbol={selectedSymbol} />
        )}
      </div>
    </div>
  );
}
